import React from 'react'
import { Box, Typography } from '@mui/material'

import GoogleIcon from '../../../icon/GoogleIcon'
import MuiFilterSelect from '../../../components/Filters/MuiFilterSelect'
import SearchInput from '../../../components/SearchInput'
import {
  STORE_RELATIONS_FILTER_CONFIG,
  STORE_RELATIONS_FILTER_SEARCH_PLACEHOLDER,
  STORE_RELATIONS_UNASSIGNED_USER_FILTER_LABEL,
  STORE_RELATIONS_UNASSIGNED_USER_FILTER_VALUE
} from '../constants/storeConstants'

const StoreRelationsFilters = ({
  supplierFilter,
  buyerFilter,
  clientFilter,
  userFilter,
  statusFilter,
  supplierOptions,
  buyerOptions,
  clientOptions,
  userOptions,
  statusOptions,
  searchInput,
  onSearchChange,
  onSearchEnter,
  onClearSearch,
  onSupplierChange,
  onBuyerChange,
  onClientChange,
  onUserChange,
  onStatusChange,
  onReset,
  shouldShowReset = false
}) => {
  const filterValueMap = {
    supplier: supplierFilter,
    buyer: buyerFilter,
    client: clientFilter,
    user: userFilter,
    status: statusFilter
  }

  const filterOptionsMap = {
    supplier: supplierOptions,
    buyer: buyerOptions,
    client: clientOptions,
    user: userOptions,
    status: statusOptions
  }

  const filterChangeMap = {
    supplier: onSupplierChange,
    buyer: onBuyerChange,
    client: onClientChange,
    user: onUserChange,
    status: onStatusChange
  }

  const filterPinnedOptionsMap = {
    user: [
      {
        label: STORE_RELATIONS_UNASSIGNED_USER_FILTER_LABEL,
        value: STORE_RELATIONS_UNASSIGNED_USER_FILTER_VALUE
      }
    ]
  }

  return (
    <>
      <Typography variant="subtitle1" className="store-relations-filters__title">
        Filtrar relaciones:
      </Typography>

      <Box className="store-relations-filters">
        <Box className="store-relations-filters__group">
          <GoogleIcon className="filter-icon-poc oc-icon-primary" name="page_info" size={22} />

          {STORE_RELATIONS_FILTER_CONFIG.map((filterConfig) => {
            const filterOptions = filterOptionsMap[filterConfig.key] || []
            const pinnedOptions = filterPinnedOptionsMap[filterConfig.key] || []
            const hasSelectableOptions = filterOptions.length > 0 || pinnedOptions.length > 0

            return (
              <Box key={filterConfig.key} className={filterConfig.widthClassName}>
                <MuiFilterSelect
                  title={filterConfig.title}
                  options={filterOptions}
                  value={filterValueMap[filterConfig.key]}
                  onChange={filterChangeMap[filterConfig.key]}
                  pinnedOptions={pinnedOptions}
                  searchable
                  disabled={!hasSelectableOptions}
                  width="100%"
                  dropdownWidth={filterConfig.dropdownWidth}
                />
              </Box>
            )
          })}
        </Box>

        <Box className="store-relations-filters__search">
          <SearchInput
            value={searchInput}
            onChange={onSearchChange}
            onEnter={onSearchEnter}
            onClear={onClearSearch}
            placeholder={STORE_RELATIONS_FILTER_SEARCH_PLACEHOLDER}
          />
        </Box>
      </Box>

      {shouldShowReset && (
        <Typography variant="body2" className="relation-poc-reset-filter" onClick={onReset}>
          Restablecer filtros aplicados
        </Typography>
      )}
    </>
  )
}

export default StoreRelationsFilters
